const NS = "fjc_offline_";

function safeGet(key) {
  try {
    const raw = localStorage.getItem(NS + key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function safeSet(key, value) {
  try {
    localStorage.setItem(NS + key, JSON.stringify(value));
  } catch {
    // storage unavailable/full - silently ignore, offline cache is best-effort
  }
}

export function isNetworkError(err) {
  return !err?.response || err.code === "ERR_NETWORK" || !navigator.onLine;
}

// Runs apiCall(); caches the result on success, falls back to the last cached
// value on a network error (offline). Re-throws real server errors as-is.
export async function withCache(cacheKey, apiCall) {
  try {
    const data = await apiCall();
    safeSet(cacheKey, data);
    return { data, fromCache: false };
  } catch (err) {
    if (isNetworkError(err)) {
      const cached = safeGet(cacheKey);
      if (cached !== null) return { data: cached, fromCache: true };
    }
    throw err;
  }
}

export function getCached(cacheKey) {
  return safeGet(cacheKey);
}

const QUEUE_KEY = "pending_inspections";

export function getQueue() {
  return safeGet(QUEUE_KEY) || [];
}

export function queueInspection(payload) {
  const queue = getQueue();
  const item = { local_id: `LOC-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`, payload, queued_at: new Date().toISOString() };
  queue.push(item);
  safeSet(QUEUE_KEY, queue);
  window.dispatchEvent(new Event("offline-queue-changed"));
  return item;
}

export function removeFromQueue(localId) {
  const queue = getQueue().filter((i) => i.local_id !== localId);
  safeSet(QUEUE_KEY, queue);
  window.dispatchEvent(new Event("offline-queue-changed"));
}
